import { ComparisonDelta } from '../models';

export const UP_ARROW = '▲';
export const DOWN_ARROW = '▼';

export function symbolForDelta(delta: ComparisonDelta): string {
  if (delta.absolute === 0) {
    return '';
  }

  return delta.absolute < 0 ? DOWN_ARROW : UP_ARROW;
}
